import React, { useState } from 'react';
import styled from 'styled-components';

const SignInWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f9f2e6;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const SignInContainer = styled.div`
  width: 100%;
  max-width: 400px;
  height: 100%;
  padding: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const Label = styled.label`
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #555;
`;

const Input = styled.input`
  padding: 0.875rem 1rem;
  border: 1px solid #d8c7d3;
  border-radius: 8px;
  font-size: 1rem;
  width: 100%;
  color: #000000;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  
  &::placeholder {
    color: #9a8f95;
  }
  &:focus {
    outline: none;
    border-color: #C242A0;
    box-shadow: 0 0 0 3px rgba(194, 66, 160, 0.2);
  }
`;

const Button = styled.button`
  padding: 0.875rem 1rem;
  background-color: #C242A0;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  -webkit-appearance: none;
  appearance: none;
  
  &:hover {
    background-color: #a83a8c;
  }
  
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(194, 66, 160, 0.25);
  }
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: #e53935;
  font-size: 0.85rem;
  margin-top: 0.5rem;
`;

const SignIn = () => {
  const [accountName, setAccountName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!accountName.trim()) {
      setError('Please enter an account name');
      return;
    }
    
    // Check if the account name contains spaces
    if (accountName.includes(' ')) {
      setError('Account name cannot contain spaces');
      return;
    }
    
    // Redirect the top-level window (parent) to the Zenoti URL
    window.top.location.href = `https://${accountName.trim()}.zenoti.com`;
  };

  return (
    <SignInWrapper>
      <SignInContainer>
        
      <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="accountName">Enter your account name or employer name to continue</Label>
        <Input
              id="accountName"
          type="text"
          value={accountName}
          onChange={(e) => setAccountName(e.target.value)}
          placeholder="Enter account name or employer name"
          autoFocus
          required
        />
        {error && <ErrorMessage>{error}</ErrorMessage>}
          </FormGroup>
          
        <Button type="submit" disabled={!accountName.trim()}>
          Continue
        </Button>
      </Form>
      </SignInContainer>
    </SignInWrapper>
  );
};

export default SignIn;
